import getNavigationState from "../navigation/navigation-state.js";

export function initBreadcrumb() {
  console.log("INIT BREADCRUMB RUNNING");

  const list = document.querySelector("#breadcrumb-list");
  if (!list) return;

  const state = getNavigationState();

  list.closest(".sz-breadcrumb").hidden = false;

  // -----------------------------------------
  // HOME CRUMB
  // -----------------------------------------

  const homeLi = document.createElement("li");
  homeLi.className = "sz-breadcrumb__home";

  const homeLink = document.createElement("a");
  homeLink.href = "/";
  homeLink.textContent = "Student Zone";

  homeLi.appendChild(homeLink);
  list.appendChild(homeLi);

  // -----------------------------------------
  // TRAIL
  // -----------------------------------------

  if (!state?.trail?.length) return;

  state.trail.forEach((node, index) => {
    const li = document.createElement("li");

    if (index === state.trail.length - 1) {
      li.textContent = node.label;
      li.setAttribute("aria-current", "page");
    } else {
      const a = document.createElement("a");
      a.href = node.url;
      a.textContent = node.label;
      li.appendChild(a);
    }

    list.appendChild(li);
  });
}